function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M11.998 5.937l5.446 5.757-.007 6.705H15.11v-5.603a.79.79 0 00-.778-.8H9.667a.789.789 0 00-.778.8v5.603H6.556l.004-6.738 5.438-5.724zm1.558 7.66v4.802h-3.112v-4.803h3.112zm4.996-3.055l-5.996-6.31a.785.785 0 00-1.112 0l-5.997 6.311c-.284.3-.447.72-.447 1.151V18.4C5 19.282 5.659 20 6.468 20h11.063c.81 0 1.469-.718 1.469-1.601v-6.705c0-.431-.163-.85-.448-1.152z"
});

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgHome;